import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "coach-edit" }
const _hoisted_2 = { class: "coach-edit-content" }
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "photo-section" }
const _hoisted_7 = { class: "photo-upload" }
const _hoisted_8 = {
  key: 0,
  class: "photo-preview"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = { class: "form-section" }
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-section" }
const _hoisted_16 = { class: "form-row" }
const _hoisted_17 = { class: "form-row" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "form-group checkbox-group" }
const _hoisted_20 = { class: "checkbox-label" }
const _hoisted_21 = { class: "form-section" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "specialty-dropdown" }
const _hoisted_25 = {
  key: 0,
  class: "specialty-tags"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "error"
}
const _hoisted_29 = { class: "form-section" }
const _hoisted_30 = {
  key: 0,
  class: "error-section"
}
const _hoisted_31 = { class: "error" }
const _hoisted_32 = { class: "submit-section" }
const _hoisted_33 = { class: "modal-footer" }

import { ref, computed, onMounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import TopbarOrganism from '@/components/organisms/topbar-organism/TopbarOrganism.vue';
  import InputMolecule from '@/components/molecules/input-molecule/InputMolecule.vue';
  import ButtonAtom from '@/components/atoms/ButtonAtom.vue';
  import coachService, {
    CreateCoachData,
  } from '@/services/coach/coach.service';
  import Coach from '@/models/coach/coach.model';
  import {
    SelectOption,
    transformToSelectOptions,
  } from '@/shared/selectOption';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CoachEditView',
  setup(__props) {

  const router = useRouter();
  const route = useRoute();

  // Get coach ID from route params
  const coachId = route.params.id as string;

  // Form data
  const formData = ref<CreateCoachData>({
    coach_name: '',
    coach_lastname: '',
    coach_email: '',
    coach_headline: '',
    coach_bio: '',
    scheduling_link: '',
    license_number: '',
    specialities_description: '',
    years_of_experience: undefined,
    client_count: '',
    price_per_hour: undefined,
    speciality_ids: [],
    free_session_scheduling_link: '',
    free_block_session_link: '',
    individual_session_link: '',
    coach_level: 1,
    is_instructor: false,
  });

  // File handling
  const coachPhoto = ref<File | null>(null);
  const coachPhotoPreview = ref<string>('');
  const existingPhotoUrl = ref<string>('');
  const photoInput = ref<HTMLInputElement | null>(null);

  // Form state
  const loading = ref(false);
  const loadingCoach = ref(false);
  const errors = ref<Record<string, string>>({});

  // Success modal
  const showSuccessModal = ref(false);

  // Specialties
  const specialityOptions = ref<SelectOption[]>([]);
  const selectedSpecialities = ref<SelectOption[]>([]);

  // Computed for form validation
  const isFormValid = computed(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid =
      formData.value.coach_email && emailRegex.test(formData.value.coach_email);

    return (
      formData.value.coach_name &&
      formData.value.coach_lastname &&
      isEmailValid &&
      formData.value.coach_headline &&
      (coachPhoto.value || existingPhotoUrl.value)
    );
  });

  function hasTransparency(img: HTMLImageElement): boolean {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return false;
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    for (let i = 3; i < imageData.length; i += 4) {
      if (imageData[i] < 255) {
        return true;
      }
    }
    return false;
  }

  // Handle file selection
  const handlePhotoChange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];

    if (file) {
      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png', 'image/avif'];
      if (!allowedTypes.includes(file.type)) {
        errors.value.photo =
          'Invalid file type. Please select JPEG, PNG, or AVIF image.';
        return;
      }

      // Validate file size (optional, e.g., max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        errors.value.photo =
          'File size too large. Please select a file under 5MB.';
        return;
      }

      coachPhoto.value = file;
      errors.value.photo = '';

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          if (hasTransparency(img)) {
            errors.value.photo =
              'Image contains transparent pixels. Please choose another image.';
            coachPhoto.value = null;
            coachPhotoPreview.value = '';
            return;
          }
          coachPhoto.value = file;
          coachPhotoPreview.value = e.target?.result as string;
          errors.value.photo = '';
        };
        img.src = e.target?.result as string;
      };
      reader.readAsDataURL(file);
    }
  };

  // Trigger file input
  const triggerPhotoUpload = () => {
    photoInput.value?.click();
  };

  // Email validation
  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      formData.value.coach_email &&
      !emailRegex.test(formData.value.coach_email)
    ) {
      errors.value.email = 'Please enter a valid email address.';
    } else {
      errors.value.email = '';
    }
  };

  // Load existing coach data
  const loadCoachData = async () => {
    if (!coachId) {
      router.push('/coaches-list');
      return;
    }

    loadingCoach.value = true;
    errors.value = {};

    try {
      const response = await coachService.getById(coachId);

      // Handle different response formats - API might return data wrapped in a response object
      const coach = (response as { data?: Coach }).data || response;

      // Populate form data by updating individual fields
      formData.value.coach_name = coach.coach_name || '';
      formData.value.coach_lastname = coach.coach_lastname || '';
      formData.value.coach_email = coach.coach_email || '';
      formData.value.coach_headline = coach.coach_headline || '';
      formData.value.coach_bio = coach.coach_bio || '';
      formData.value.scheduling_link = coach.scheduling_link || '';
      formData.value.license_number = coach.license_number || '';
      formData.value.specialities_description =
        coach.specialities_description || '';
      formData.value.years_of_experience = coach.years_of_experience;
      formData.value.client_count = coach.client_count || '';
      formData.value.price_per_hour = coach.price_per_hour;
      formData.value.speciality_ids = coach.speciality_ids || [];
      formData.value.free_session_scheduling_link =
        coach.free_session_scheduling_link || '';
      formData.value.free_block_session_link =
        coach.free_block_scheduling_link || '';
      formData.value.coach_level = coach.coach_level || 1;
      formData.value.is_instructor = coach.is_instructor || false;
      formData.value.individual_session_link =
        coach.individual_session_link || '';

      // Set existing photo
      if (coach.coach_photo) {
        existingPhotoUrl.value = coach.coach_photo;
        coachPhotoPreview.value = coach.coach_photo;
      }

      // Set selected specialities after loading coach data
      setSelectedSpecialities();
    } catch (error) {
      console.error('Error loading coach data:', error);
      errors.value.form = 'Failed to load coach data.';
    } finally {
      loadingCoach.value = false;
    }
  };

  // Submit form
  const submitForm = async () => {
    validateEmail();

    if (!isFormValid.value) {
      errors.value.form =
        'Please fill in all required fields with valid information.';
      return;
    }

    loading.value = true;
    errors.value = {};

    try {
      const files = coachPhoto.value ? [coachPhoto.value] : undefined;
      const response = await coachService.update(
        coachId,
        formData.value,
        files,
      );

      if (response.success || response.data) {
        showSuccessModal.value = true;
      } else {
        errors.value.form = response.message || 'Failed to update coach.';
      }
    } catch (error) {
      console.error('Error updating coach:', error);
      errors.value.form = 'An error occurred while updating the coach.';
    } finally {
      loading.value = false;
    }
  };

  // Fetch specialities
  const fetchSpecialities = async () => {
    try {
      const response = await coachService.getSpecialities();
      specialityOptions.value = transformToSelectOptions(
        response.data,
        'speciality_id',
        'speciality_name',
      );

      // Set selected specialities if coach data already has speciality_ids
      setSelectedSpecialities();
    } catch (error) {
      console.error('Error fetching specialities:', error);
      errors.value.specialities = 'Failed to load specialities.';
    }
  };

  // Set selected specialities based on form data
  const setSelectedSpecialities = () => {
    if (
      formData.value.speciality_ids &&
      formData.value.speciality_ids.length > 0 &&
      specialityOptions.value.length > 0
    ) {
      selectedSpecialities.value = specialityOptions.value.filter((option) =>
        formData.value.speciality_ids?.includes(option.id),
      );
    }
  };

  // Add specialty
  const addSpecialty = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    const specialtyId = target.value;

    if (specialtyId && selectedSpecialities.value.length < 3) {
      const specialty = specialityOptions.value.find(
        (s) => s.id === specialtyId,
      );
      if (
        specialty &&
        !selectedSpecialities.value.some((s) => s.id === specialtyId)
      ) {
        selectedSpecialities.value.push(specialty);
        formData.value.speciality_ids = selectedSpecialities.value.map(
          (s) => s.id,
        );
      }
    }
    target.value = ''; // Reset the select
  };

  // Remove specialty
  const removeSpecialty = (specialty: SelectOption) => {
    selectedSpecialities.value = selectedSpecialities.value.filter(
      (s) => s.id !== specialty.id,
    );
    formData.value.speciality_ids = selectedSpecialities.value.map((s) => s.id);
  };

  // Available specialities (excluding already selected ones)
  const availableSpecialities = computed(() => {
    return specialityOptions.value.filter(
      (option) =>
        !selectedSpecialities.value.some(
          (selected) => selected.id === option.id,
        ),
    );
  });

  // Close modal and navigate to coaches list
  const closeSuccessModal = () => {
    showSuccessModal.value = false;
    router.push('/coaches-list');
  };

  // Initialize data
  onMounted(async () => {
    await fetchSpecialities();
    await loadCoachData();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopbarOrganism, {
      linkText: "Back to coaches",
      showIcon: true,
      icon: "angleLeft",
      primaryButtonText: "Update Coach",
      route: "/coaches-list",
      onPrimaryClick: submitForm,
      primaryButtonDisabled: !isFormValid.value || loading.value || loadingCoach.value
    }, null, 8, ["primaryButtonDisabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[35] || (_cache[35] = _createElementVNode("h2", null, "Edit Coach", -1)),
        (loadingCoach.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[17] || (_cache[17] = [
              _createElementVNode("p", null, "Loading coach data...", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Coach Photo *", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("input", {
                    ref_key: "photoInput",
                    ref: photoInput,
                    type: "file",
                    accept: "image/jpeg,image/png,image/avif",
                    onChange: handlePhotoChange,
                    style: {"display":"none"}
                  }, null, 544),
                  (coachPhotoPreview.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: coachPhotoPreview.value,
                          alt: "Coach photo preview"
                        }, null, 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(ButtonAtom, {
                    class: "btn btn-secondary",
                    onClick: triggerPhotoUpload,
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(coachPhotoPreview.value ? 'Change Photo' : 'Upload Photo'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                (errors.value.photo)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.value.photo), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[21] || (_cache[21] = _createElementVNode("h3", null, "Basic Information", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(InputMolecule, {
                    title: "First Name*",
                    label: "Coach's first name",
                    id: "coach_name",
                    placeholder: "Enter first name",
                    modelValue: formData.value.coach_name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.coach_name) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputMolecule, {
                    title: "Last Name*",
                    label: "Coach's last name",
                    id: "coach_lastname",
                    placeholder: "Enter last name",
                    modelValue: formData.value.coach_lastname,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.coach_lastname) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode(InputMolecule, {
                  title: "Email*",
                  label: "Coach's email address",
                  id: "coach_email",
                  placeholder: "Enter email address",
                  type: "email",
                  modelValue: formData.value.coach_email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.coach_email) = $event)),
                  onBlur: validateEmail
                }, null, 8, ["modelValue"]),
                (errors.value.email)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errors.value.email), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputMolecule, {
                  title: "Headline*",
                  label: "Professional headline",
                  id: "coach_headline",
                  placeholder: "e.g., Certified Life Coach & Mental Health Professional",
                  modelValue: formData.value.coach_headline,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.coach_headline) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Bio", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("label", { for: "coach_bio" }, "Coach's biography", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "coach_bio",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.coach_bio) = $event)),
                    placeholder: "Tell us about the coach's background and expertise...",
                    rows: "4",
                    class: "textarea"
                  }, null, 512), [
                    [_vModelText, formData.value.coach_bio]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Professional Information", -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(InputMolecule, {
                    title: "Years of Experience",
                    label: "Years of professional experience",
                    id: "years_of_experience",
                    placeholder: "e.g., 5",
                    type: "number",
                    modelValue: formData.value.years_of_experience?.toString() || '',
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (
                  formData.value.years_of_experience = $event
                    ? Number($event)
                    : undefined
                ))
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputMolecule, {
                    title: "Client Count",
                    label: "Number of clients served",
                    id: "client_count",
                    placeholder: "e.g., 100+",
                    modelValue: formData.value.client_count,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.client_count) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(InputMolecule, {
                    title: "Price per Hour",
                    label: "Hourly rate in USD",
                    id: "price_per_hour",
                    placeholder: "e.g., 150",
                    type: "number",
                    modelValue: formData.value.price_per_hour?.toString() || '',
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (
                  formData.value.price_per_hour = $event ? Number($event) : undefined
                ))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[23] || (_cache[23] = _createElementVNode("h4", null, "Coach Level", -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("label", { for: "coach_level" }, "Select coach experience level", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "coach_level",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.coach_level) = $event)),
                      class: "select-input"
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("option", { value: "1" }, "Level 1", -1),
                      _createElementVNode("option", { value: "2" }, "Level 2", -1),
                      _createElementVNode("option", { value: "3" }, "Level 3", -1)
                    ]), 512), [
                      [_vModelSelect, formData.value.coach_level]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.is_instructor) = $event)),
                      class: "checkbox-input"
                    }, null, 512), [
                      [_vModelCheckbox, formData.value.is_instructor]
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "checkbox-text" }, "Is Instructor", -1))
                  ]),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "checkbox-description" }, " Check if this coach is also an instructor ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[33] || (_cache[33] = _createElementVNode("h3", null, "Specialties", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _cache[28] || (_cache[28] = _createElementVNode("h4", null, "Specialties Description", -1)),
                  _cache[29] || (_cache[29] = _createElementVNode("label", { for: "specialities_description" }, "Description of specialties", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "specialities_description",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.specialities_description) = $event)),
                    placeholder: "Describe the coach's areas of specialization...",
                    rows: "3",
                    class: "textarea"
                  }, null, 512), [
                    [_vModelText, formData.value.specialities_description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[31] || (_cache[31] = _createElementVNode("h4", null, "Specialties", -1)),
                  _cache[32] || (_cache[32] = _createElementVNode("label", { for: "speciality_ids" }, "Select coach specialties (maximum 3)", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    (selectedSpecialities.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSpecialities.value, (specialty) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: specialty.id,
                              class: "specialty-tag"
                            }, [
                              _createTextVNode(_toDisplayString(specialty.value) + " ", 1),
                              _createElementVNode("span", {
                                class: "remove-tag",
                                onClick: ($event: any) => (removeSpecialty(specialty))
                              }, "×", 8, _hoisted_26)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (selectedSpecialities.value.length < 3)
                      ? (_openBlock(), _createElementBlock("select", {
                          key: 1,
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (addSpecialty($event))),
                          class: "specialty-select"
                        }, [
                          _cache[30] || (_cache[30] = _createElementVNode("option", { value: "" }, "Choose a specialty...", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSpecialities.value, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option.id,
                              value: option.id
                            }, _toDisplayString(option.value), 9, _hoisted_27))
                          }), 128))
                        ], 32))
                      : _createCommentVNode("", true)
                  ]),
                  (errors.value.specialities)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(errors.value.specialities), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[34] || (_cache[34] = _createElementVNode("h3", null, "Contact Information", -1)),
                _createVNode(InputMolecule, {
                  title: "Scheduling Link",
                  label: "Link for booking appointments",
                  id: "scheduling_link",
                  placeholder: "https://calendly.com/coach-name",
                  modelValue: formData.value.scheduling_link,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.scheduling_link) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(InputMolecule, {
                  title: "Free Block Scheduling Link",
                  label: "Link for booking free block session (3 sessions)",
                  id: "free_block_scheduling_link",
                  placeholder: "https://calendly.com/coach-name",
                  modelValue: formData.value.free_block_session_link,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.free_block_session_link) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(InputMolecule, {
                  title: "Individual Session Link",
                  label: "Link for booking individual session",
                  id: "individual_session_link",
                  placeholder: "https://calendly.com/coach-name",
                  modelValue: formData.value.individual_session_link,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.individual_session_link) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(InputMolecule, {
                  title: "Free Session Scheduling Link",
                  label: "Link for booking free sessions",
                  id: "free_session_scheduling_link",
                  placeholder: "https://calendly.com/coach-name",
                  modelValue: formData.value.free_session_scheduling_link,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.free_session_scheduling_link) = $event))
                }, null, 8, ["modelValue"])
              ]),
              (errors.value.form)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(errors.value.form), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(ButtonAtom, {
                  class: "btn btn-primary",
                  onClick: submitForm,
                  disabled: !isFormValid.value || loading.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(loading.value ? 'Updating...' : 'Update Coach'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
      ])
    ]),
    (showSuccessModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: closeSuccessModal
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "modal-header" }, [
              _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Coach Updated Successfully!", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: closeSuccessModal
              }, "×")
            ]),
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "modal-body" }, [
              _createElementVNode("p", { class: "success-message" }, " The coach profile has been updated successfully. ")
            ], -1)),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(ButtonAtom, {
                class: "btn btn-primary",
                onClick: closeSuccessModal,
                disabled: false
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createTextVNode(" Continue to Coaches List ")
                ])),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})